<template>
  <div class="gif-preview">
    <div v-if="playing" class="gifpreview--holder">
      <slot name="gif"></slot>
    </div>
    <div v-if="!playing" class="gifpreview--poster">
      <slot name="poster"></slot>
    </div>
    <button
      type="button"
      class="preview--toggle"
      :class="playclass"
      :aria-label="ariaLabel"
      @click="playing = !playing"
    >
      <svg v-if="playing" class="icon icon-stop">
        <title>stop</title>
        <use
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          xlink:href="#stop"
        ></use>
      </svg>
      <svg v-if="!playing" class="icon icon-play">
        <title>play</title>
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#play"></use>
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'gifpreview',
  props: {
    ariaLabel: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      playing: true,
    };
  },
  computed: {
    playclass() {
      if (this.playing) {
        return 'gifpreview--playing';
      }
      return 'gifpreview--paused';
    },
  },
};
</script>
